<template>
  <LayoutWrapper>
    <BuildingOverview />
    <FormDialog v-if="layoutStore.isFormDialogOpen"></FormDialog>
    <OrderForm v-if="layoutStore.isOrderFormOpen" />
  </LayoutWrapper>
</template>

<script setup lang="ts">
import BuildingOverview from '@/components/BuildingOverview/BuildingOverview.vue';
import FormDialog from '@/components/UI/Modal/FormDialog.vue';
import { useLayoutStore } from '@/store/layout/layoutStore';
import LayoutWrapper from '@/components/LayoutWrapper.vue';
import OrderForm from '@/components/Forms/OrderForm.vue';

const layoutStore = useLayoutStore();
</script>
